/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteTemplateSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteTemplateSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteTemplateSecurity = {
  option1?: DeleteTemplateSecurityOption1 | undefined;
  option2?: DeleteTemplateSecurityOption2 | undefined;
};

export type DeleteTemplateRequest = {
  /**
   * The ID of the prompt template
   */
  id?: string | undefined;
  /**
   * The name of the prompt template
   */
  name?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteTemplateSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteTemplateSecurityOption1$outboundSchema: z.ZodMiniType<
  DeleteTemplateSecurityOption1$Outbound,
  DeleteTemplateSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteTemplateSecurityOption1ToJSON(
  deleteTemplateSecurityOption1: DeleteTemplateSecurityOption1,
): string {
  return JSON.stringify(
    DeleteTemplateSecurityOption1$outboundSchema.parse(
      deleteTemplateSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteTemplateSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteTemplateSecurityOption2$outboundSchema: z.ZodMiniType<
  DeleteTemplateSecurityOption2$Outbound,
  DeleteTemplateSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function deleteTemplateSecurityOption2ToJSON(
  deleteTemplateSecurityOption2: DeleteTemplateSecurityOption2,
): string {
  return JSON.stringify(
    DeleteTemplateSecurityOption2$outboundSchema.parse(
      deleteTemplateSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteTemplateSecurity$Outbound = {
  Option1?: DeleteTemplateSecurityOption1$Outbound | undefined;
  Option2?: DeleteTemplateSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteTemplateSecurity$outboundSchema: z.ZodMiniType<
  DeleteTemplateSecurity$Outbound,
  DeleteTemplateSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteTemplateSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteTemplateSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteTemplateSecurityToJSON(
  deleteTemplateSecurity: DeleteTemplateSecurity,
): string {
  return JSON.stringify(
    DeleteTemplateSecurity$outboundSchema.parse(deleteTemplateSecurity),
  );
}

/** @internal */
export type DeleteTemplateRequest$Outbound = {
  id?: string | undefined;
  name?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteTemplateRequest$outboundSchema: z.ZodMiniType<
  DeleteTemplateRequest$Outbound,
  DeleteTemplateRequest
> = z.pipe(
  z.object({
    id: z.optional(z.string()),
    name: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteTemplateRequestToJSON(
  deleteTemplateRequest: DeleteTemplateRequest,
): string {
  return JSON.stringify(
    DeleteTemplateRequest$outboundSchema.parse(deleteTemplateRequest),
  );
}
